
// exporting the component
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SideBar',
  emits: ['onThemeChange'],
  data() {
    return {
      activeDarkMode: false
    };
  },
  computed: {
    buttonText() {
      if (this.activeDarkMode) {
        return 'Desativar modo escuro';
      }
      return 'Ativar modo escuro';
    }
  },
  methods: {
    changeTheme() {
      this.activeDarkMode = !this.activeDarkMode;
      this.$emit('onThemeChange', this.activeDarkMode);
    }
  }
});
